import { createRouter, createWebHistory } from 'vue-router'
import { AppConstant } from '@/supports/app.constant'
import LoginComponent from '@/pages/auth/login/LoginComponent.vue'
import DashboardComponent from '@/pages/dashboard/DashboardComponent.vue'
import OnePlusControlComponent from "@/layouts/oneplus-control/OnePlusControlComponent.vue";
import PartnerListComponent from "@/pages/partners/list/PartnerListComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import CommonService from "@/services/common.service";
import PartnerInviteComponent from "@/pages/partners/invite/PartnerInviteComponent.vue";
import InviteCooperateComponent from "@/pages/partners/cooperate/InviteCooperateComponent.vue";
import RegisterComponent from "@/pages/auth/register/RegisterComponent.vue";
import ProductComponent from "@/pages/products/ProductComponent.vue";
import ProductCreateComponent from "@/pages/products/create/ProductCreateComponent.vue";
import DeliveryDataComponent from "@/pages/invoice/master-delivery-data/DeliveryDataComponent.vue";
import DeliveryDataComponentList from "@/pages/invoice/delivery-data/list-exchange-delivery/DeliveryDataComponent.vue";
import DeliveryDataCreateComponent from "@/pages/invoice/master-delivery-data/create/DeliveryDataCreateComponent.vue";
import ExchangeDeliveryData from "@/pages/invoice/delivery-data/exchange-delivery-data/ExchangeDeliveryData.vue";
import PageNotFound from "@/pages/errors/404/404PageComponent.vue";
import DeliveryDataDetailComponent
  from "@/pages/invoice/delivery-data/delivery-data-detail/DeliveryDataDetailComponent.vue";
import SettingFormatFileComponent from "@/pages/settings/format-file/SettingFormatFileComponent.vue";
import CreateSettingFormatFileComponent from "@/pages/settings/format-file/create/CreateSettingFormatFileComponent.vue";
import WarehouseComponent from "@/pages/warehouses/WarehouseComponent.vue";
import WarehouseUpdateOrCreateComponent from "@/pages/warehouses/action/WarehouseUpdateOrCreateComponent.vue";
import InventoryComponent from "@/pages/warehouses/inventory/InventoryComponent.vue";
import ArrivalComponent from "@/pages/warehouses/arrival/ArrivalComponent.vue";
import ArrivalUpdateOrCreateComponent from "@/pages/warehouses/action/ArrivalUpdateOrCreateComponent.vue";
import SyncKiovietComponent from "@/pages/settings/sync-kioviets/SyncKiovietComponent.vue";
import DeliveryKiotvietDetailComponent
  from "@/pages/settings/sync-kioviets/show-tabs/tab-action-kiot/tab-delivery/delivery-data-detail/DeliveryKiotvietDetailComponent.vue";
import StoreComponent from "@/pages/stores/StoreComponent.vue";
import StoreCreateOrUpdateComponent from "@/pages/stores/create/StoreCreateOrUpdateComponent.vue";
import ConnectGHTKComponent from "@/pages/thirdParty/ghtk/ConnectGHTK/ConnectGHTKComponent.vue";
import GHTKComponent from "@/pages/thirdParty/ghtk/GHTKComponent.vue";
import OrderGHTKComponent from "@/pages/thirdParty/ghtk/OrderGHTK/OrderGHTKComponent.vue";
import CreateOrderGHTKComponent from "@/pages/thirdParty/ghtk/OrderGHTK/CreateOrderGHTKComponent.vue";
import ConnectZaloComponent from "@/pages/thirdParty/zalo/connect-zalo/connect/ConnectZaloComponent.vue";
import CallbackZaloComponent from "@/pages/thirdParty/zalo/connect-zalo/callback/CallbackZaloComponent.vue";
import ZaloServiceComponent from "@/pages/thirdParty/zalo/zalo-service/ZaloServiceComponent.vue";
import SettingMessageZaloComponent from "@/pages/thirdParty/zalo/setting-message/SettingMessageZaloComponent.vue";
// import SettingMessageZaloComponent from "@/pages/thirdParty/zalo/setting-message/SettingMessageZaloComponent.vue";
import EmployerComponent from "@/pages/employers/EmployerComponent.vue";
import EmployerCreateComponent from "@/pages/employers/create/EmployerCreateComponent.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '',
      name: 'TopPage',
      component: OnePlusControlComponent,
      meta: {
        title: 'INVOICEX',
        requiresAuth: true
      },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: DashboardComponent,
          meta: {
            title: 'DASHBOARD'
          },
        },
        {
          path: '/partner/list',
          name: 'partner-list',
          component: PartnerListComponent,
          meta: {
            title: 'Danh sách đối tác',

          },
        },
        {
          path: '/partner/invite',
          name: 'partner-invite',
          component: PartnerInviteComponent,
          meta: {
            title: 'Mời đối tác',

          },
        },
        {
          path: '/product',
          name: 'product',
          component: ProductComponent,
          meta: {
            title: 'Sản phẩm',

          },
        },
        {
          path: '/product/:mode/:id?',
          name: 'product-action',
          component: ProductCreateComponent,
          meta: {
            title: 'Tạo sản phẩm',
          },
        },
        {
          path: '/delivery-data',
          name: 'delivery-data',
          component: DeliveryDataComponent,
          meta: {
            title: 'KHO DỮ LIỆU GIAO HÀNG',

          },
        },
        {
          path: '/delivery-data/:mode/:id?',
          name: 'delivery-data-create',
          component: DeliveryDataCreateComponent,
          meta: {
            title: 'Tạo dữ liệu giao hàng',

          },
        },
        {
          path: '/exchange-delivery-data/create',
          name: 'exchange-delivery-data-create',
          component: ExchangeDeliveryData,
          meta: {
            title: 'Gửi dữ liệu giao hàng',

          },
        },
        {
          path: '/exchange-delivery-data',
          name: 'exchange-delivery-data',
          component: DeliveryDataComponentList,
          meta: {
            title: 'GIAO HÀNG',

          },
        },
        {
          path: '/delivery-data-detail',
          name: 'DeliveryDetail',
          component: DeliveryDataDetailComponent,
          meta: {
            title: 'Chi tiết dữ liệu giao hàng',

          },
        },
        {
          path: '/setting/format-file',
          name: 'SettingFormatFile',
          component: SettingFormatFileComponent,
          meta: {
            title: 'Nhập File - Xuất File',
          },
        },
        {
          path: '/setting/format-file/:mode/:id?',
          name: 'CreateSettingFormatFile',
          component: CreateSettingFormatFileComponent,
          meta: {
            title: 'Tạo cài đặt file',
          },
        },
        {
          path: '/warehouse',
          name: 'warehouse',
          component: WarehouseComponent,
          meta: {
            title: 'Kho hàng',
          },
        },
        {
          path: '/warehouse/:mode/:id?',
          name: 'WarehouseAction',
          component: WarehouseUpdateOrCreateComponent,
          meta: {
            title: 'Tạo cài đặt file',
          },
        },
        {
          path: 'warehouse/management-inventory',
          name: 'management-inventory',
          component: InventoryComponent,
          meta: {
            title: 'Quản lý tồn kho',
          },
        },
        {
          path: 'warehouse/arrival',
          name: 'arrival',
          component: ArrivalComponent,
          meta: {
            title: 'Nhập hàng',
          },
        },
        {
          path: 'warehouse/arrival/:mode/:id?',
          name: 'actionArrival',
          component: ArrivalUpdateOrCreateComponent,
          meta: {
            title: 'Tạo nhập hàng',
          }
        },
        {
          path: '/third-party/sync-kiotviet',
          name: 'SyncKioviet',
          component: SyncKiovietComponent,
          meta: {
            title: 'Đồng Bộ Kioviet',
          },
        },
        {
          path: '/callback-zalo/:company_code',
          name: 'CallbackZalo',
          component: CallbackZaloComponent,
          meta: {
            title: 'Liên kết tới zalo',
          },
        },
        {
          path: '/delivery-data-kioviet-detail',
          name: 'DeliveryKiotvietDetail',
          component: DeliveryKiotvietDetailComponent,
          meta: {
            title: 'Chi tiết dữ liệu giao hàng kiotviet',

          },
        },
        {
          path: '/stores',
          name: 'store',
          component: StoreComponent,
          meta: {
            title: 'Cửa hàng',
          },
        },
        {
          path: '/stores/:mode/:id?',
          name: 'StoreAction',
          component: StoreCreateOrUpdateComponent,
          meta: {
            title: 'Tạo cửa hàng',
          },
        },
        {
          path: '/third-party/ghtk',
          name: 'SyncGHTK',
          component: GHTKComponent,
          meta: {
            title: 'Liên kết với GHTK',
          },
        },
        {
          path: '/third-party/ghtk/:mode/:id?',
          name: 'SyncGHTKAction',
          component: ConnectGHTKComponent,
          meta: {
            title: 'Tạo cửa hàng',
          },
        },
        {
          path: '/third-party/ghtk/order',
          name: 'OrderGHTK',
          component: OrderGHTKComponent,
          meta: {
            title: 'Tạo cửa hàng',
          },
        },
        {
          path: '/third-party/ghtk/order/:mode/:id?',
          name: 'OrderGHTKAction',
          component: CreateOrderGHTKComponent,
          meta: {
            title: 'Tạo cửa hàng',
          },
        },
        {
          path: '/third-party/zalo/connect',
          name: 'SyncZalo',
          component: ConnectZaloComponent,
          meta: {
            title: 'Liên kết tới zalo',
          },
        },
        {
          path: '/third-party/zalo/user',
          name: 'UserZalo',
          component: ZaloServiceComponent,
          meta: {
            title: 'Danh sách người dùng',
          }
        },
        {
          path: '/third-party/zalo/setting-message',
          name: 'messageZalo',
          component: SettingMessageZaloComponent,
          meta: {
            title: 'Cài đặt tin nhắn',
          }
        },
        {
          path: '/employers',
          name: 'employer',
          component: EmployerComponent,
          meta: {
            title: 'Danh sách nhân viên',

          },
        },
        {
          path: '/employer/create',
          name: 'createEmployer',
          component: EmployerCreateComponent,
          meta: {
            title: 'Thêm Mới Nhân Viên',
          },
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginComponent,
      meta: {
        title: AppConstant.ROUTER_LOGIN_TITLE,
        requiresAuth: false
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: RegisterComponent,
      meta: {
        title: AppConstant.ROUTER_LOGIN_TITLE,
        requiresAuth: false
      }
    },
    {
      path: '/invite-cooperate',
      name: 'Invite Cooperate',
      component: InviteCooperateComponent,
      meta: {
        title: AppConstant.ROUTER_LOGIN_TITLE,
        requiresAuth: false
      }
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound,
      meta: {
        title: AppConstant.ROUTER_LOGIN_TITLE,
        requiresAuth: false
      }
    },
    // {
    //   path: '/404',
    //   name: 'pageNotFound',
    //   component: page404Component,
    //   meta: {
    //     title: AppConstant.ROUTER_404_TITLE,
    //   }
    // },
    // {
    //   path: '/:pathMatch(.*)*',
    //   name: 'pageNotFound',
    //   component: page404Component,
    //   meta: {
    //     title: AppConstant.ROUTER_404_TITLE,
    //   }
    // }
  ],
})
router.beforeEach((to, from, next) => {
  const accessToken = CommonService.getTokenAuth();
  const accountStore = useAccountStore()
  if(accessToken && !accountStore.isLogin) {
    accountStore.account = {
      'username' : localStorage.getItem(AppConstant.KEY_USERNAME),
      'userid' : localStorage.getItem(AppConstant.KEY_USERID),
      'company': {
        'id' : localStorage.getItem(AppConstant.KEY_COMPANY_ID),
        'company_zip' : localStorage.getItem(AppConstant.KEY_COMPANY_CODE),
        'company_name' : localStorage.getItem(AppConstant.KEY_COMPANY_NAME),
      }
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!accessToken) {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    if(to.path === '/login' && accessToken) {
      next({ name: 'dashboard' })
    }else {
      next()
    }
  }
})
export default router